module.exports = __webpack_public_path__ + "static/media/electricista.0ae63fb5.svg";